import useOrganization from '../../hooks/use-organization';
import LocationDetails from './organization/details';
import StationDetails from './stationDetails';

function IndexStationDetails() {
  const organizationInfo = useOrganization();
  return Boolean(organizationInfo?.id) ? <LocationDetails /> : <StationDetails />;
}

export default IndexStationDetails;
